import Vue from 'vue'
import store from "@/store/store";
import {actionTypes} from "@/store/actionTypes";
import {AppServiceEventBus, AppServiceEventBusType} from '@/eventbus/appservice.eventbus'
import $filters from "@/modules/fptai/filters/filters";

const AppService = {
    promise: {
        [AppServiceEventBusType.CONFIRM]: null,
        [AppServiceEventBusType.INPUT_TEXT]: null,
        [AppServiceEventBusType.TEXT_EDITOR]: null
    },
    loading(show = true) {
        store.dispatch(actionTypes.LOADING, show)
    },
    showLoading() {
        store.dispatch(actionTypes.LOADING, true)
    },
    hideLoading() {
        store.dispatch(actionTypes.LOADING, false)
    },
    confirm(message, notice) {
        AppServiceEventBus.$emit(AppServiceEventBusType.CONFIRM, {message, notice})
        return new Promise((resolve, reject) => {
            this.promise.CONFIRM = {resolve, reject}
        })
    },
    inform(message, options) {
        AppServiceEventBus.$emit(AppServiceEventBusType.INFORM, {message, options})
    },
    closeInform() {
        AppServiceEventBus.$emit(AppServiceEventBusType.CLOSE_INFORM)
    },
    toast(message, type, title) {
        AppServiceEventBus.$emit(AppServiceEventBusType.TOAST, {
            group: 'app',
            title: title ? title : $filters.tc(type),
            text: message,
            duration: 3500,
            type: type
        })
    },
    toastSuccess(message, title) {
        this.toast(message, 'success', title)
    },
    toastError(message, title) {
        this.toast(message, 'error', title)
    },
    toastInfo(message, title) {
        this.toast(message, 'info', title)
    },
    toastWarning(message, title) {
        this.toast(message, 'warning', title)
    },
    handleRequestSuccess(alternateMessage) {
        return () => {
            this.toastSuccess(alternateMessage ? alternateMessage : window.vueapp.$t('successful'))
        }
    },
    handleRequestError(alternateErrorMessage, hideLoading = false) {
        return error => {
            if (hideLoading) {
                this.hideLoading()
            }

            if (error.response?.data) {
                // check errorMessage is array
                let data = error.response.data
                if (Array.isArray(data)) {
                    this.toastError(data.join(''))
                    return
                }

                // check errorMessage has message
                if (data.message) {
                    this.toastError(data.message)
                    return
                }

                // check errorMessage has detail
                if (data.detail) {
                    this.toastError(data.detail)
                    return
                }

                // check errorMessage is object
                if (typeof data === 'object') {
                    this.toastError(JSON.stringify(data))
                    return
                }

                // check errorMessage is empty
                if (JSON.stringify(data) === '{}') {
                    return
                }

                this.toastError(JSON.stringify(data))
            } else if (alternateErrorMessage) {
                this.toastError(alternateErrorMessage)
            } else {
                this.toastError(window.vueapp.$t('error'))
            }
        }
    },
    correctHeaders(headers, sortable) {
        for (let header of headers) {
            header.text = $filters.capitalize(header.text)
            header.sortable = sortable || header.sortable || false
            header.visible = typeof header.visible === 'boolean' ? header.visible : true
        }
        return headers.filter(item => item.visible)
    },
    getLocale() {
        return window.vueapp.$i18n.locale.split('-')[0]
    },
    mapPagination(pagination) {
        let str = 'page=' + pagination.page
        str += '&page_size=' + pagination.rowsPerPage
        if (pagination.sortBy) {
            let orderDirection = pagination.descending ? '-' : ''
            str += '&ordering=' + orderDirection + pagination.sortBy
        }
        return str
    },
    mapPaginationQuery(pagination) {
        let query = {
            page: pagination.page,
            page_size: pagination.rowsPerPage,
            ordering: ''
        }
        if (pagination.sortBy) {
            let orderDirection = pagination.descending ? '-' : ''
            query.ordering += orderDirection + pagination.sortBy
        }
        return query
    },
    mapFilterPagination(filter) {
        if (!filter) {
            return
        }
        filter.page = filter.page || 1
        filter.page_size = filter.page_size || filter.rowsPerPage || 10
        if (!filter.ordering && filter.sortBy) {
            let orderDirection = filter.descending ? '-' : ''
            filter.ordering = orderDirection + filter.sortBy
        }
        return filter
    },
    dataLoading(boolean) {
        store.dispatch(actionTypes.DATA_LOADING, boolean)
    },
    inputText(title) {
        AppServiceEventBus.$emit(AppServiceEventBusType.INPUT_TEXT, title)
        return new Promise((resolve, reject) => {
            this.promise.INPUT_TEXT = {resolve, reject}
        })
    },
    textEditor (data) {
        AppServiceEventBus.$emit(AppServiceEventBusType.TEXT_EDITOR, data)
        return new Promise((resolve, reject) => {
            this.promise.TEXT_EDITOR = { resolve, reject }
        })
    },
}

for (let i in AppService.promise) {
    AppServiceEventBus.$on(AppServiceEventBusType[i + '_DONE'], data => {
        if (AppService.promise[i]) {
            AppService.promise[i].resolve(data)
        }
    })
}

Vue.prototype.$appService = AppService

export default AppService
